webpackJsonp([103057277810609],{

/***/ 3728:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.rightStyle = exports.introStyle = exports.sectionStyle = exports.sectionsStyle = exports.innerWrapperStyle = exports.quadrantsWrapper = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var quadrantsWrapper = exports.quadrantsWrapper = _globalStyles.quadrantsStyle;
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px',
		overflowX: 'hidden'
	});
	
	var sectionsStyle = /*#__PURE__*/exports.sectionsStyle = (0, _emotion.css)({
		borderBottom: '1px solid ' + _globalStyles.lightGrey
	});
	
	var sectionStyle = exports.sectionStyle = function sectionStyle(background) {
		return (0, _globalStyles.contentSection)(background, '30px');
	};
	
	var introStyle = /*#__PURE__*/exports.introStyle = (0, _emotion.css)({
		display: 'table',
		margin: '60px auto',
		padding: '0 20px',
		width: '100%',
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		'& > div': {
			display: 'table-cell',
	
			verticalAlign: 'top',
			'&:first-child': {
				width: '60%'
			}
		},
		'& h1': _extends({}, _globalStyles.museo900, {
			color: _globalStyles.darkGrey,
			fontSize: '36px',
			lineHeight: '36px',
			marginTop: '0',
			marginBottom: '11px',
			fontWeight: 'normal'
		}),
		'& p': (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
			width: '400px'
		})),
		'& h2': {
			color: _globalStyles.grey,
			fontSize: '10px',
			lineHeight: '12px',
			letterSpacing: '0.5px',
			fontWeight: 'bold',
			textTransform: 'uppercase',
			marginTop: '0',
			marginBottom: '6px'
		},
		'& span': (0, _emotion.cx)(_globalStyles.headingSmall, /*#__PURE__*/(0, _emotion.css)({
			display: 'block',
			lineHeight: '18px'
		}))
	});
	
	var rightStyle = /*#__PURE__*/exports.rightStyle = (0, _emotion.css)({
		'& div:first-child': {
			marginBottom: '39px'
		}
	});

/***/ }),

/***/ 1150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _navManager = __webpack_require__(22);
	
	var _pageHeader = __webpack_require__(19);
	
	var _cards = __webpack_require__(17);
	
	var _policyCard = __webpack_require__(216);
	
	var _headerNswYellow = __webpack_require__(3728);
	
	var _headerNswYellow2 = _interopRequireDefault(_headerNswYellow);
	
	var _section = __webpack_require__(485);
	
	var _globalStyles = __webpack_require__(4);
	
	var _link = __webpack_require__(9);
	
	var _pagination = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SteeringCommitteeDetailPage = function (_React$PureComponent) {
		_inherits(SteeringCommitteeDetailPage, _React$PureComponent);
	
		function SteeringCommitteeDetailPage() {
			_classCallCheck(this, SteeringCommitteeDetailPage);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		SteeringCommitteeDetailPage.prototype.render = function render() {
			var _props$pathContext = this.props.pathContext,
			    pageNumber = _props$pathContext.pageNumber,
			    totalPages = _props$pathContext.totalPages;
			var _props$data = this.props.data,
			    page = _props$data.page,
			    policies = _props$data.policies;
	
			var pageSettings = page.edges[0].node;
	
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: pageSettings.main_heading },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: pageSettings.main_heading })
				),
				_react2.default.createElement(_pageHeader.PageHeader, {
					background: '#F5A81E',
					titleText: pageSettings.main_heading,
					icon: _headerNswYellow2.default,
					titleTextColor: '#fff'
				}),
				_react2.default.createElement(
					'div',
					{ className: _section.sectionsStyle },
					_react2.default.createElement(
						'section',
						{ className: (0, _section.sectionStyle)() },
						_react2.default.createElement(
							'div',
							{ className: _section.innerWrapperStyle },
							_react2.default.createElement(
								'div',
								{ className: (0, _globalStyles.cardSection)() },
								_react2.default.createElement(
									_cards.Cards,
									{ columns: 4 },
									policies && policies.edges.map(function (_ref, index) {
										var node = _ref.node;
										return _react2.default.createElement(_policyCard.PolicyCard, {
											key: index,
											href: node.attachments[0].file,
											title: node.title,
											date: node.date
										});
									})
								)
							)
						)
					),
					totalPages !== 1 && _react2.default.createElement(_pagination.Pagination, {
						initialPage: pageNumber,
						pageCount: totalPages,
						onPageChange: function onPageChange(page) {
							(0, _link.navigateTo)(page === 1 ? '/policy-and-service-development/steering-committee' : '/policy-and-service-development/steering-committee/' + page);
						}
					})
				)
			);
		};
	
		return SteeringCommitteeDetailPage;
	}(_react2.default.PureComponent);
	
	SteeringCommitteeDetailPage.propTypes = {
		pathContext: _propTypes2.default.shape({
			pageNumber: _propTypes2.default.number.isRequired,
			totalPages: _propTypes2.default.number.isRequired
		}).isRequired,
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						main_heading: _propTypes2.default.string.isRequired
					})
				}))
			}),
	
			policies: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						id: _propTypes2.default.string,
						title: _propTypes2.default.string,
						type: _propTypes2.default.string,
						date: _propTypes2.default.string
					}).isRequired
				}).isRequired)
			}).isRequired
		}).isRequired
	};
	exports.default = SteeringCommitteeDetailPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-policy-and-service-development-steering-committee-js-49f3355b6007ea48e88b.js